import { useEffect } from 'react';
import api from 'api';

export default function useFormLoad(jobID, jobStore, company, onError) {
  const job = jobStore.items.get(jobID);
  useEffect(() => {
    if (job && job.form === undefined) {
      job.loadForm();
    } else if (jobStore.formState === 'loaded') {
      api.jobs.loadForm(company, jobID).then((res) => {
        if (!res.error) {
          jobStore.addOrUpdate(res.data);
        } else {
          onError();
        }
      });
    }
  }, [job, jobStore.formState, jobID, jobStore, onError, company]);
}
